import React from 'react';

import { flagStyles } from '../settings';

const SvgTD = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5112px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTD;
